<template>
  <div>
    <md-steppers :md-active-step.sync="active" md-vertical md-linear>
      <md-step
        id="first"
        md-label="Step 1: Add Identification Number"
        md-description
        :md-error="firstStepError"
        :md-editable="false"
        :md-done.sync="first"
      >
        <b-row v-if="searchByIdCode">
          <b-col>
            <md-field :class="{ 'md-invalid': searchInputErr_idCode }">
              <label>{{i18n_local.pid}}</label>
              <md-input v-model="searchInput_idCode"></md-input>
              <span class="md-error">{{searchInputErr_idCode}}</span>
              <span class="md-helper-text"><i><a @click="switchSearchMethod()"> {{i18n_local.or_user_name}}</a></i></span>
            </md-field>
          </b-col>
        </b-row>

        <b-row v-else>
          <b-col>
            <md-field :class="{ 'md-invalid': searchInputErr_ssnTax }">
              <label>{{i18n_local.ssn}}</label>
              <md-input v-model="searchInput_ssnTax"></md-input>
              <span class="md-error">{{searchInputErr_ssnTax}}</span>
              <span class="md-helper-text"><i><a @click="switchSearchMethod()"> {{i18n_local.or_user_id}}</a></i></span>

            </md-field>
            <md-field :class="{ 'md-invalid': searchInputErr_givenName }">
              <label>{{i18n_local.given_name}}</label>
              <md-input v-model="searchInput_givenName"></md-input>
              <span class="md-error">{{searchInputErr_givenName}}</span>
            </md-field>
            <md-field :class="{ 'md-invalid': searchInputErr_surname }">
              <label>{{i18n_local.surname}}</label>
              <md-input v-model="searchInput_surname"></md-input>
              <span class="md-error">{{searchInputErr_surname}}</span>
            </md-field>
            <date-input ref="searchInputFormRef_dob" :title="i18n_local.dob" />
          </b-col>
        </b-row>

        <md-progress-spinner
          v-if="searching"
          :md-diameter="30"
          :md-stroke="3"
          md-mode="indeterminate"
          style="color:white"
        ></md-progress-spinner>
        <moow-button v-else
          class="mt-3"
          :type="['light', 'outlined']"
          btnText="Next"
          @mClick="takeStep('first', 'second')"
        />
      </md-step>

      <md-step
        id="second"
        md-label="Step 2: Add Other Details"
        :md-error="secondStepError"
        :md-editable="false"
        :md-done.sync="second"
      >
        <b-row v-if="searching">
          <b-col>
            <md-progress-spinner
              :md-diameter="30"
              :md-stroke="3"
              md-mode="indeterminate"
              style="color:white"
            ></md-progress-spinner>
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col cols="6">
            <p @click="takeStep('second', 'first')" :disabled="searching" class="text-button">
              <md-icon>keyboard_arrow_up</md-icon>Back
            </p>

            <div v-if="searchByIdCode">
              <md-field :class="{ 'md-invalid': searchInputErr_givenName }">
                <label>{{i18n_local.given_name}}</label>
                <md-input v-model="person.givenName"></md-input>
                <span class="md-error">{{searchInputErr_givenName}}</span>
              </md-field>
              <md-field :class="{ 'md-invalid': searchInputErr_surname }">
                <label>{{i18n_local.surname}}</label>
                <md-input v-model="person.surname"></md-input>
                <span class="md-error">{{searchInputErr_surname}}</span>
              </md-field>
              <date-input ref="dateInputFormRef_dob" title="Date Of Birth" :date="person.dob" />
            </div>
            <md-autocomplete
              v-model="selectedNationality"
              :md-options="countryOptions"
              md-dense
              :md-open-on-focus="false"
              :md-fuzzy-search="false"
              :class="{ 'md-invalid': searchInputErr_nationality }"
            >
              <label>{{i18n_local.nationality}}</label>
              <span class="md-error">{{searchInputErr_nationality}}</span>
            </md-autocomplete>
            <md-field :class="{ 'md-invalid': inputErr_email }">
              <label>{{i18n_local.email}}</label>
              <md-input v-model="person.email"></md-input>
              <span class="md-error">{{inputErr_email}}</span>
            </md-field>
            <md-field :class="{ 'md-invalid': inputErr_address }">
              <label>{{i18n_local.residential_address}}</label>
              <md-input v-model="person.address"></md-input>
              <span class="md-error">{{inputErr_address}}</span>
            </md-field>
            <md-field :class="{ 'md-invalid': inputErr_phone }">
              <label>{{i18n_local.phone}} (optional)</label>
              <md-input v-model="person.phone"></md-input>
              <span class="md-error">{{inputErr_phone}}</span>
            </md-field>
          </b-col>
        </b-row>
      </md-step>
    </md-steppers>
  </div>
</template>
<script>
import { getPrivatePerson } from "../../platform/person/repository/personRepository";
import { countryList } from "../../assets/text/countryIsoList";
import { countryMap } from "../../assets/text/countryIsoMap";
import { countryMapReverse } from "../../assets/text/countryIsoMapReverse";
import DateInput from "@/components/utils/dateInput.vue";
import { mapGetters } from "vuex";
export default {
  props: {
    personId: {
      required: false
    }
  },
  components: {
    "date-input": DateInput
  },
  data() {
    return {
      searchInput_idCode: "",
      searchInput_ssnTax: "",
      searchInput_givenName: "",
      searchInput_surname: "",
      //   selectedDob: "",
      searchByIdCode: true,
      searching: false,
      person: {
        _id: "",
        nationality: "",
        dob: "",
        givenName: "",
        surname: "",
        idCode: "",
        email: "",
        phone: "",
        address: ""
      },
      emptyPerson: {
        _id: "",
        nationality: "",
        dob: "",
        givenName: "",
        surname: "",
        idCode: "",
        email: "",
        phone: "",
        address: ""
      },
      personSearcException: "",
      searchInputErr_idCode: "",
      searchInputErr_ssnTax: "",
      searchInputErr_givenName: "",
      searchInputErr_surname: "",
      searchInputErr_dob: "",
      searchInputErr_nationality: "",
      inputErr_email: "",
      inputErr_phone: "",
      inputErr_wos: "",
      inputErr_address: "",
      active: "first",
      first: false,
      second: false,
      firstStepError: null,
      secondStepError: null,
      countryOptions: countryList,
      selectedNationality: "",
      rules: {
        emailRule: /.+@.+/,
        includeLetterRule: /[a-z]/,
        includeNumberRule: /\d/
      },
      today: new Date(),
      searchingForNewPerson: true
    };
  },
  watch: {
    "person.givenName": function(val) {
      if (val) this.searchInputErr_givenName = "";
      // else this.searchInputErr_givenName = "Required";
    },
    "person.surname": function(val) {
      if (val) this.searchInputErr_surname = "";
      // else this.searchInputErr_surname = "Required";
    },
    "person.dob": function(val) {
      if (val) this.searchInputErr_dob = "";
      // else this.searchInputErr_dob = "Required";
    },
    "person.email": function(val) {
      // if (!val) this.inputErr_email = "Required";
      if (val && this.rules.emailRule.test(val)) this.inputErr_email = "";
      else if (val) this.inputErr_email = "check format";
    },
    "person.phone": function(val) {
      if (val) this.inputErr_phone = "";
      // else this.inputErr_phone = "Required";
    },
    "person.address": function(val) {
      if (val) this.inputErr_address = "";
      // else this.inputErr_address = "Required";
    },
    selectedNationality: function(val) {
      if (val) this.searchInputErr_nationality = "";
      // else this.searchInputErr_nationality = "Required";
    },
    searchInput_idCode: function(val, oldVal) {
      if (val) {
        this.firstStepError = null;
        this.searchInputErr_idCode = "";
        this.searchInputErr_ssnTax = "";
        this.searchInputErr_surname = "";
        this.searchInputErr_givenName = "";
        this.searchInputErr_dob = "";
      }

      if (oldVal && oldVal != val) this.searchingForNewPerson = true;
    },
    searchInput_ssnTax: function(val, oldVal) {
      if (val) {
        this.firstStepError = null;
        this.searchInputErr_ssnTax = "";
        this.searchInputErr_idCode = "";
      }
      if (oldVal && oldVal != val) this.searchingForNewPerson = true;
    },
    searchInput_surname: function(val, oldVal) {
      if (val) this.searchInputErr_surname = "";
      else this.searchInputErr_surname = "Required";

      if (oldVal && oldVal != val) this.searchingForNewPerson = true;
    },
    searchInput_givenName: function(val, oldVal) {
      if (val) this.searchInputErr_givenName = "";
      else this.searchInputErr_givenName = "Required";

      if (oldVal && oldVal != val) this.searchingForNewPerson = true;
    }
    // selectedDob: function(val){
    //     if(val) this.searchInputErr_dob = ""
    //     else this.searchInputErr_dob = "Required"
    // }
  },
  computed: {
        ...mapGetters("internationalizationModule", ["i18n_local"]),

  },
  created() {
    if (this.personId) this.searchPerson({ id: this.personId });
  },
  methods: {
    clearResultsForm() {
      this.person._id = "";
      this.person.nationality = "";
      this.person.email = "";
      this.person.phone = "";
      this.person.address = "";
      if (this.searchByIdCode) {
        this.person.dob = "";
        this.person.givenName = "";
        this.person.surname = "";
        this.person.ssnTaxNr = "";
      } else {
        this.person.idCode = "";
      }
    },
    validDoB(selectedDate) {
      // return true if valid
      try {
        return this.today.getFullYear() - selectedDate.getFullYear() < 16;
      } catch (error) {
        return true;
      }
    },
    switchSearchMethod() {
      this.searchByIdCode = !this.searchByIdCode;
      this.searchInput_idCode = "";
      this.searchInput_ssnTax = "";
      // this.selectedDob=""
      this.searchInput_givenName = "";
      this.searchInput_surname = "";
      this.searchInputErr_idCode = "";
      this.searchInputErr_ssnTax = "";
      this.searchInputErr_givenName = "";
      this.searchInputErr_surname = "";
      this.searchInputErr_dob = "";
      this.searchInputErr_nationality = "";
      this.firstStepError = "";

      this.$refs.dateInputFormRef_dob
        ? this.$refs.dateInputFormRef_dob.clear()
        : void 0;
      this.$refs.searchInputFormRef_dob
        ? this.$refs.searchInputFormRef_dob.clear()
        : void 0;
    },
    takeStep(id, index) {
      if (id == "first") {
        if (this.validateSearchForm()) {
          this.search();
          this[id] = true;
          if (index) this.active = index;
          this.firstStepError = null;
          this.$emit("emitShowSaveIdent", true)
        } else {
          this.firstStepError = "Review";
        }
      } else {
        this[id] = true;
        if (index){
          this.active = index;
          this.$emit("emitShowSaveIdent", false)
        } 

      }
    },
    search() {
      this.secondStepError = null
      this.mapSearchFormToPerson();
      if (this.searchByIdCode)
        this.searchPerson({ byIdCode: true, idCode: this.searchInput_idCode });
      else this.searchPerson(this.makePersonQueryForSsnTax());
    },
    mapSearchFormToPerson() {
      if (this.searchByIdCode) {
        this.person.idCode = this.searchInput_idCode;
      } else {
        this.person.ssnTaxNr = this.searchInput_ssnTax;
        this.person.givenName = this.searchInput_givenName;
        this.person.surname = this.searchInput_surname;
        this.person.dob = this.$refs.searchInputFormRef_dob.getValidDate();
      }
    },
    makePersonQueryForSsnTax() {
      var validDate = this.$refs.searchInputFormRef_dob.getValidDate();
      return {
        bySsnTax: true,
        ssnTaxNr: this.searchInput_ssnTax,
        givenName: this.searchInput_givenName,
        surname: this.searchInput_surname,
        dob: validDate
      };
    },
    searchPerson(personQuery) {
      this.searching = true;
      var person;
      getPrivatePerson(personQuery)
        .then(resp => {
          person = resp;
        })
        .catch(err => {
          this.clearResultsForm();
        })
        .finally(f => {
          this.mapPersonToForm(person);
          this.searching = false;
        });
    },
    validateSearchForm() {
      var valid = true;
      if (!this.searchInput_idCode) {
        if (!this.searchInput_ssnTax) {
          this.searchInputErr_idCode = "Required";
          this.searchInputErr_ssnTax = "Required";
          valid = false;
        }
        if (!this.searchInput_givenName) {
          this.searchInputErr_givenName = "Required";
          valid = false;
        }
        if (!this.searchInput_surname) {
          this.searchInputErr_surname = "Required";
          valid = false;
        }
        if (!this.$refs.searchInputFormRef_dob || !this.$refs.searchInputFormRef_dob.validateForm()) {
          valid = false;
        }
      }
      return valid;
    },
    mapPersonToForm(person) {
      if (person) {
        this.person.givenName =
          person.givenName.charAt(0).toUpperCase() + person.givenName.slice(1);
        this.person.surname =
          person.surname.charAt(0).toUpperCase() + person.surname.slice(1);
        this.person._id = person._id;
        this.person.dob = person.dob;
        this.selectedNationality = countryMap[person.nationalities[0]];
        this.searchInput_idCode = person.idCode;
        this.searchInputErr_ssnTax = person.ssnTaxNr;
        return;
      } else if(this.searchByIdCode && this.searchingForNewPerson){
          // person not found by searching with ID code, remove all but idCode
          this.person.givenName = "";
          this.person.surname = "";
          this.person.nationality = "";
          this.person.email = "";
          this.person.phone = "";
          this.person.address = "";
          this.person.dob = "";
          this.person._id = "";
          this.person.ssnTaxNr = "";
      }else if (this.searchingForNewPerson) {
          // person not found by searching with SSN, remove all but name, dob and ssnTaxNr
          this.person.nationality = "";
          this.person.email = "";
          this.person.phone = "";
          this.person.address = "";
          this.person._id = "";
      }
    },
    convertFormToPerson() {
      this.person.nationality = countryMapReverse[this.selectedNationality];
      if (!this.person.dob && this.$refs.dateInputFormRef_dob) {
        var personDob = this.$refs.dateInputFormRef_dob.getValidDate();
        personDob?this.person.dob = personDob: void 0;
      }
      return this.person;
    },
    validatePerson() {
      var valid = true;
      var validPerson = this.convertFormToPerson();

      if (!validPerson.nationality) {
        this.searchInputErr_nationality = "Invalid";
        valid = false;
      }
      if (!validPerson.givenName) {
        this.searchInputErr_givenName = "Required";
        valid = false;
      }
      if (!validPerson.surname) {
        this.searchInputErr_surname = "Required";
        valid = false;
      }
      if (!validPerson.dob) {
        this.searchInputErr_dob = "Required";
        valid = false;
      }
      if (!validPerson.idCode && !validPerson.ssnTaxNr) {
        if (!validPerson.idCode) this.searchInputErr_idCode = "Required";
        if (!validPerson.ssnTaxNr) this.searchInputErr_ssnTax = "Required";
        valid = false;
      }
      if (!validPerson.email || this.inputErr_email) {
        this.inputErr_email = "Check value";
        valid = false;
      }

      if (!validPerson.address) {
        this.inputErr_address = "Required";
        valid = false;
      }

      return valid;
    },
    getValidPerson() {
      var valid = this.validatePerson();
      if (valid){
        this.firstStepError = null
        this.secondStepError = null
        return this.convertFormToPerson();
      } else this.secondStepError = "Review";
      return valid;
    }
  }
};
</script>
<style scoped>
@import "../../assets/styles/global.css";
</style>



// WEBPACK FOOTER //
// src/components/person/privatePersonSearch.vue